import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const IconHome = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

const IconDocs = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
  </svg>
);

const IconJobs = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const IconPrep = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

const IconPlus = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="16" />
    <line x1="8" y1="12" x2="16" y2="12" />
  </svg>
);

const BottomTabBar = ({ onNewGeneration }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isInResults = location.pathname === '/create';
  const isInDashboard = location.pathname === '/dashboard';

  return (
    <div className="bottom-tab-bar">
      <button
        className={`bottom-tab ${isInResults ? 'bottom-tab--active' : ''}`}
        onClick={() => onNewGeneration ? onNewGeneration() : navigate('/create')}
        aria-label="Generate"
      >
        <IconHome />
        <span className="bottom-tab-label">Generate</span>
      </button>

      <button
        className={`bottom-tab ${isInDashboard ? 'bottom-tab--active' : ''}`}
        onClick={() => navigate('/dashboard')}
        aria-label="My Documents"
      >
        <IconDocs />
        <span className="bottom-tab-label">Saved</span>
      </button>

      <button
        className="bottom-tab bottom-tab--action"
        onClick={() => onNewGeneration ? onNewGeneration() : navigate('/create')}
        aria-label="New Generation"
      >
        <IconPlus />
        <span className="bottom-tab-label">New</span>
      </button>

      <button
        className="bottom-tab"
        style={{ opacity: 0.35 }}
        disabled
        aria-label="Job Tracker — Coming Soon"
      >
        <IconJobs />
        <span className="bottom-tab-label">Jobs</span>
      </button>

      <button
        className="bottom-tab"
        style={{ opacity: 0.35 }}
        disabled
        aria-label="Interview Prep — Coming Soon"
      >
        <IconPrep />
        <span className="bottom-tab-label">Prep</span>
      </button>
    </div>
  );
};

export default BottomTabBar;
